import type { ApiAreaOfFocus } from '#/api/types/ApiAreaOfFocus';
import { DetailsList } from '#/components/DetailsList/DetailsList';
import { DetailsListItem } from '#/components/DetailsList/Item/DetailsListItem';
import { useI18n } from '#/i18n/hooks/useI18n';
import { AREAS_OF_FOCUS } from '#/utils/constants/general/areasOfFocus';
import { INTERNSHIP_PAYMENT_TYPE } from '#/utils/constants/general/internshipPaymentType';
import { humanDate } from '#/utils/date';

type Props = {
  academicCredits: boolean | null;
  applicationDeadline: string | null;
  areasOfFocus: ApiAreaOfFocus[];
  endDate: string | null;
  hoursPerWeek: number | null;
  payment: string | null;
  startDate: string | null;
  wage: string | null;
};

export function InternshipDetailsList({
  academicCredits,
  applicationDeadline,
  areasOfFocus,
  endDate,
  hoursPerWeek,
  payment,
  startDate,
  wage,
}: Props) {
  const { i18n, locale } = useI18n();

  return (
    <DetailsList>
      {startDate && (
        <DetailsListItem
          title={i18n('Start Date')}
          iconName="calendar"
          value={humanDate({ date: startDate, locale })}
        />
      )}

      {endDate && (
        <DetailsListItem
          title={i18n('End Date')}
          iconName="calendar"
          value={humanDate({ date: endDate, locale })}
        />
      )}

      {applicationDeadline && (
        <DetailsListItem
          title={i18n('Application Deadline')}
          iconName="hourglass"
          value={humanDate({ date: applicationDeadline, locale })}
        />
      )}

      {academicCredits && (
        <DetailsListItem
          title={i18n('Internship Benefits')}
          iconName="academic-credits"
          value={i18n('Academic Credits')}
        />
      )}

      {payment && (
        <DetailsListItem
          title={i18n('Payment')}
          iconName="coin"
          value={
            INTERNSHIP_PAYMENT_TYPE(i18n)[
              // TODO: refactor to get rid of typecasting
              payment as keyof typeof INTERNSHIP_PAYMENT_TYPE
            ]
          }
        />
      )}

      {wage && (
        <DetailsListItem
          title={i18n('Stipend / Wage')}
          iconName="coin"
          value={wage}
        />
      )}

      {hoursPerWeek && (
        <DetailsListItem
          title={i18n('Hours Per Week')}
          iconName="hourglass"
          value={hoursPerWeek}
        />
      )}

      {areasOfFocus.length > 0 && (
        <DetailsListItem
          iconName="globe"
          title={i18n('Cause Areas')}
          value={areasOfFocus
            .map((item) => AREAS_OF_FOCUS(i18n)[item])
            .join(', ')}
        />
      )}
    </DetailsList>
  );
}
